<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area customer-useparts">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <!-- <div class="page-name">{{  page_header }}</div> -->
                <h1 class="page-title"> {{page_header}} </h1>
                <button type="submit" v-on:click.prevent="returnOnListing()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div v-show="isPinnacle && cartUsage" class="forms-container">
                    <div class="row no-margin">
                        <template v-for="(mapper, index) in barcodeArr">
                            <div v-if="mapper.isColorChnage" style="background: #ddd; padding-top: 30px;" class="col-12 forms-block" :key="'div-tag ' + index">
                                <div class="col-4 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Scanned Part# :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isBlurEventCall">
                                            <!--@input="barcodeEventCallback(index)"-->
                                            <input ref="barcodeTextRef" class="form-control" id="barcodeText" placeholder="" v-model="mapper.barcodeText">
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.barcodeText}}</span>
                                            <div class="form-label text-danger">{{mapper.note}}</div>
                                        </template>
                                    </div>
                                </div>
                                <!-- Qty -->
                                <div v-if="mapper.isBlurEventCall" class="col-3 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Qty :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isDisabledQty">
                                            <input @input="mapper.qtyError = ''" class="qty form-control" :id="'qty' + index" placeholder="Enter Qty" v-model="mapper.qty">
                                            <div class="form-label">Qty on Hand : {{mapper.maxQty}}</div>
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.qty}}</span>
                                        </template>
                                        <div class="requiredstar">*</div>
                                        <span class="text-danger">{{mapper.qtyError}}</span>                                

                                    </div>
                                </div>
                                <!-- Work Order -->
                                <div v-if="mapper.isBlurEventCall" class="col-4 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Word Order :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isDisabledQty">
                                            <input @input="mapper.unitNumberError = ''" class="unitNumber form-control" :id="'unitNumber' + index" placeholder="Enter Work Order" v-model="mapper.unitNumber">
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.unitNumber}}</span>
                                        </template>
                                        <div class="requiredstar">*</div>
                                        <span class="text-danger">{{mapper.unitNumberError}}</span>                                

                                    </div>
                                </div>
                                <template v-if="mapper.isBlurEventCall">
                                    <div class="col-1 forms-block">
                                        <button type="button" v-on:click="removeBarcode(mapper, index)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </div>
                            <div v-else :key="'div-tag ' + index" class="col-12 forms-block">
                                <div class="col-4 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Scanned Part# :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isBlurEventCall">
                                            <!--@input="barcodeEventCallback(index)"-->
                                            <input ref="barcodeTextRef" class="form-control" id="barcodeText" placeholder="" v-model="mapper.barcodeText">
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.barcodeText}}</span>
                                            <div class="form-label text-danger">{{mapper.note}}</div>
                                        </template>
                                    </div>
                                </div>
                                <!-- Qty -->
                                <div v-if="mapper.isBlurEventCall" class="col-3 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Qty :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isDisabledQty">
                                            <input @input="mapper.qtyError = ''" class="qty form-control" :id="'qty' + index" placeholder="Enter Qty" v-model="mapper.qty">
                                            <div class="form-label">Qty on Hand : {{mapper.maxQty}}</div>
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.qty}}</span>
                                        </template>
                                        <div class="requiredstar">*</div>
                                        <span class="text-danger">{{mapper.qtyError}}</span>                                

                                    </div>
                                </div>
                                <!-- Work Order -->
                                <div v-if="mapper.isBlurEventCall" class="col-4 forms-block">
                                    <div class="col-3 paddingleft0">
                                        <div class="form-label">Word Order :</div>
                                    </div>
                                    <div class="col-9 paddingleft0">
                                        <template v-if="!mapper.isDisabledQty">
                                            <input @input="mapper.unitNumberError = ''" class="unitNumber form-control" :id="'unitNumber' + index" placeholder="Enter Work Order" v-model="mapper.unitNumber">
                                        </template>
                                        <template v-else>
                                            <span class="form-control">{{mapper.unitNumber}}</span>
                                        </template>
                                        <div class="requiredstar">*</div>
                                        <span class="text-danger">{{mapper.unitNumberError}}</span>                                

                                    </div>
                                </div>
                                <template v-if="mapper.isBlurEventCall">
                                    <div class="col-1 forms-block">
                                        <button type="button" v-on:click="removeBarcode(mapper, index)" class="btn btn-danger">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </template>
                            </div>
                        </template>
                    </div>
                    <div class="clearfix"></div>
                    <!--Buttons-->
                    <div class="row">
                        <div class="col-12">
                            <div class="col-12">
                                <div class="button-demo">
                                    <input id="addBenifitBtn" :disabled="disableButtons.saveButton" type="submit" :value="buttonNames.saveButton" class="btn btn-primary" v-on:click.prevent="addUpdatePart()">
                                    <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="returnOnListing">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="!cartUsage" class="forms-container">
                    <div class="row no-margin">
                        <!--Part-->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Part :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="partId"
                                    name="partId"
                                    id="partId"
                                    label="text"
                                    :filterable="true"
                                    :options="partArr"
                                    :clearable=false
                                    @input="onChnagePart(partId)"
                                    placeholder="Select Part">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{partError}}</span>
                                <div class="parts-info" v-if="isCorePartAvailable">This Part has a CORE Part.</div>
                                <div class="parts-info" v-if="corePartPrice != ''">CORE Part Unit Price: <strong>${{corePartPrice}}</strong></div>
                            </div>
                        </div>

                        <!-- Work Order -->
                        <div v-if="isPartEnter" class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Work Order :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="workOrder" placeholder="Enter Work Order" v-model="workOrder">
                                <span class="text-danger">{{workOrderError}}</span>
                            </div>
                        </div>

                        <!-- Qty -->
                        <div v-if="isPartEnter" class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Qty :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="qty" placeholder="Enter Qty" v-model="qty">
                                <!-- <div class="form-label">{{partId.value}}: {{maxQty}}(Qty on Hand)</div> -->
                                <div class="form-label">Qty on Hand : {{maxQty}}</div>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{qtyError}}</span>                                
                            </div>
                        </div>
                        
                        <!-- Purchase Work Order -->
                        <div v-if="isPartEnter" class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">PO Number :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="purchaseWorkOrder" placeholder="Enter PO Number" v-model="purchaseWorkOrder">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{purchaseWorkOrderError}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo" v-if="!isViewOnly">
                        <input id="addBenifitBtn" :disabled="disableButtons.saveButton" type="submit" :value="buttonNames.saveButton" class="btn btn-primary ms-2" v-on:click.prevent="checkInventoryPart()">
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="returnOnListing">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
            <div class="medium-modal">
                <b-modal ref="my-modal" id="modallg" size="lg" :title="'Select Parts to merge (PO#: ' + purchaseWorkOrder + ')'" class="modal-section" @hidden="closeModalEvent">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="col-md-12 col-sm-12">
                            <div class="form-group">
                                <input type="checkbox" v-model="isSelectAllParts" @click="selectAllUsedParts()" class="" id="partList" />
                                <template v-if="isSelectAllParts">
                                    <label style="font-weight: bold; font-size: 18px;">
                                        Deselect All
                                    </label>
                                </template>
                                <template v-else>
                                    <label style="font-weight: bold; font-size: 18px;">
                                        Select All
                                    </label>
                                </template>
                            </div>
                        </div>

                        <template v-for="(partUsage, partUsageIndex) in partUsageArr">
                            <div class="col-md-12 col-sm-12" :key="partUsageIndex">
                                <!-- <input :value="partUsageIndex" :id="partUsageIndex" class="" type="checkbox" v-model="isSelectAllParts" @click="changeDateWisePart(partUsageIndex)"/> -->
                                <label :for="partUsageIndex" style="font-weight: bold; font-size: 18px;">{{partUsageIndex}}</label>
                            </div>
                            <template v-for="(dateWisePart, dateIndex) in partUsage">
                                <div class="col-md-12 col-sm-12" :key="partUsageIndex + dateIndex">
                                    <div class="form-group">
                                        <input :value="dateWisePart" :id="partUsageIndex + dateIndex + dateWisePart['part_name']" class="" type="checkbox" v-model="selectedPartUsage" @change="changePartUsage()"/>
                                        <label class="modal-check-lbl" :for="partUsageIndex + dateIndex + dateWisePart['part_name']" style="display: inline-block;">
                                            {{dateWisePart['part_name']}} Qty: {{dateWisePart['qty']}}, Des: {{dateWisePart['des']}}, Work Order: {{dateWisePart['work_order']}}
                                        </label>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </form>
                    <b-button type="button" class="btn btn-primary" v-on:click="submitPartUsageData($event)">Submit</b-button>
                </b-modal>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import Footer from '@/components/partials/CustomerFooter';
    import EventBus from '.././event-bus';
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import timezone from 'moment-timezone';
    import moment from 'moment';
    var self;
    export default {
        name: 'CustomerUseParts',
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer': Footer,
        },
        data() {
            return {
                isBlurEventCall: false,
                page_header:'Order Part',
                maxQty: 0,
                scannedPartId: 0,
                isPartEnter: false,
                partId: "",
                partArr: [],
                qty: "",
                workOrder: "",
                purchaseWorkOrder: "",
                editId: 0,

                partError : "",
                qtyError: "",
                workOrderError: "",
                purchaseWorkOrderError: "",
                buttonNames : {
                    saveButton : 'Submit',
                    cancel:'Cancel'
                },
                disableButtons : {
                    saveButton : false,
                },
                isFromPartModule: 'dashboard',
                isShowPurchaseOrder: false,
                auditCount: 0,
                partUsageArr: [],
                selectedPartUsage: [],
                isSelectAllParts: false,
                isPinnacle: 0,
                barcodeText: '',
                cartUsage: false,
                barcodeArr: [
                    {
                        barcodeText: '',
                        barcodeTextError: '',
                        isBlurEventCall: false,
                        qty: '',
                        qtyError: '',
                        maxQty: 0,
                        isDisabledQty: false,
                        note: '',
                        unitNumber: '',
                        unitNumberError: '',
                        isColorChnage: false,
                    },
                ],
                barcodeObject: {
                    barcodeText: '',
                    barcodeTextError: '',
                    isBlurEventCall: false,
                    qty: '',
                    qtyError: '',
                    maxQty: 0,
                    isDisabledQty: false,
                    note: '',
                    unitNumber: '',
                    unitNumberError: '',
                    isColorChnage: false,
                },
                qrcodeCount:0,
                isAuditedPart: 0,
                isCorePartAvailable: false,
                corePartPrice: '',
                isViewOnly: false
            }
        },
        watch: {
            partId: function(partId) {
               self.isPartEnter = false;
               if (partId != null || self.partId.value) {
                    self.isPartEnter = true;
                    self.getPartsCounts(self.partId.value);
               }
            }
        },
        beforeMount: function () {
            self = this;
        },
        created: function () {
        },
        mounted: function () {
            self.customerProtal();
            self.isFromPartModule = 'dashboard';
            if (typeof(self.$route.params.id) != "undefined" && self.$route.params.id != "" && self.$route.params.id != 0) {
                self.isFromPartModule = self.$route.params.isFrom;
                self.partId = {text: self.$route.params.name, value: self.$route.params.name};

                if(self.isFromPartModule == 'dashboard') {
                    console.log("Here...");
                    if (typeof(self.$route.params.qty) != "undefined" && self.$route.params.qty != "" && self.$route.params.qty != 0) {
                        self.editId = self.$route.params.id;
                    }
                    self.isAuditedPart = self.$route.params.is_audited;
                    self.qty = self.$route.params.qty;
                    self.workOrder = self.$route.params.work_order;
                    // if (self.$route.params.purchase_work_order != null) {
                    if (typeof(self.$route.params.purchase_work_order) != "undefined" && self.$route.params.purchase_work_order != "" && self.$route.params.purchase_work_order != 0 && self.$route.params.purchase_work_order != null) {
                        self.purchaseWorkOrder = self.$route.params.purchase_work_order.replace("CI-", "");
                    }
                    // mapped_id = mapped_id.replace(/,\s*$/, "");
                }
            }
            self.removeErrorMessageOnInput();
            self.getAllInventoryParts();
            if(self.isFromPartModule == 'parts') {
                EventBus.$emit("customer-menu-selection-changed", "list-inventory");
            } else {
                EventBus.$emit("customer-menu-selection-changed", "customer-cards");
            }
            self.isPinnacle = 0;
            var customerObj = localStorage.getItem("customer_obj");
            //if user logged in than remove login button and registration button
            if (customerObj != null) {
                var customerJson = JSON.parse(customerObj);
                self.isShowPurchaseOrder = false;
                if(customerJson['is_pinnacle']) {
                    self.isPinnacle = customerJson['is_pinnacle'];
                    if(self.isPinnacle == 0) {
                        self.isPinnacle = customerJson['is_leasing'];
                    }
                } else {
                    self.isPinnacle = customerJson['is_leasing'];
                }
                if(customerJson['process'] == 2) {
                    self.isShowPurchaseOrder = true;
                }
            }
            // self.$refs['my-modal'].show();
            $(self.$refs['my-modal']).on("hidden.bs.modal", self.closeModalEvent);
            self.cartUsage = false;
            if(typeof(self.$route.query.barcodeScan) != "undefined" && self.$route.query.barcodeScan != "" && self.$route.query.barcodeScan == 'Yes') {
                self.cartUsage = true;
                /* if(typeof(self.$route.query.isEdit) != "undefined" && self.$route.query.isEdit != "" && self.$route.query.isEdit == 'No') {
                    self.cartUsage = false;
                } */
                setTimeout(function() {
                    self.$refs.barcodeTextRef[0].focus();
                }, 200);
            }
            if(!self.isPinnacle) {
                self.cartUsage = false;
            }
            /* $(document).click(function() {
                setTimeout(function() {
                    self.$refs.barcodeTextRef[0].focus();
                }, 200);
            }); */
            /* $(".page-header-top-container,.app-sidebar-nav,.admin-page-content,.page-content-wrapper,.main-footer").click(function(){
                setTimeout(function() {
                    self.$refs.barcodeTextRef[0].focus();
                }, 200);
            }); */
            /* if ($(".barcodeText,.qty,.unitNumber,.btn-danger,.btn-primary,#customerGlobalSearch").is(":focus")) {

            } else {
                setTimeout(function() {
                    self.$refs.barcodeTextRef[0].focus();
                }, 200);
            }
            $('#barcodeText').keypress(function(event) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                }
            }); */
            self.qrcodeCount = 0;
            $( "#barcodeText" ).off();
            $( "#barcodeText" ).unbind("keyup");
            // $( "#barcodeText" ).unbind("keypress");
            $(document).on('keyup', "#barcodeText",self.delay(function (e) {
            // $(document).on('keypress', "#barcodeText",self.delay(function (e) {
                if(this.value.trim() != ''){
                    /* console.log('Time elapsed!', this.value); */
                    self.barcodeEventCallback(self.qrcodeCount);
                }
            }, 200));
            self.isViewOnly = JSON.parse(localStorage.getItem('view_only'));
        },
        methods: {
            onChnagePart : function (value) {
                self.partError = "";
                self.isCorePartAvailable = false;
                self.corePartPrice = '';
                if(value.is_core_part_available == 'yes') {
                    self.isCorePartAvailable = true;
                    self.corePartPrice = value.core_part_price;
                }
            },
            delay(callback, ms) {
                var timer = 0;
                return function() {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                    callback.apply(context, args);
                    }, ms || 0);
                };
            },
            removeBarcode: function(object, index) {
                self.barcodeArr.splice(index, 1);
                setTimeout(function() {
                    self.$refs.barcodeTextRef[0].focus();
                }, 200);
                self.qrcodeCount--;
            },
            barcodeEventCallback: function(barcodeIndex) {
                /* console.log(barcodeIndex);
                console.log(self.barcodeArr.length - 1); */
                if((self.barcodeArr.length - 1) == barcodeIndex){
                    self.qrcodeCount = self.barcodeArr.length;
                    /* self.partId = '';
                    if(self.barcodeText == '') {
                        return false;
                    }
                    if (self.partId == null || !self.partId.value) {
                        self.barcodeText = self.barcodeText.substring(6);
                        self.partId = {text: self.barcodeText, value: self.barcodeText};
                        self.isBlurEventCall = true;
                    } */
                    var obj = self.barcodeArr[barcodeIndex];
                    if(obj.barcodeText == '') {
                        return false;
                    }
                    obj.barcodeText = obj.barcodeText.replace(/-/g, '');
                    obj.barcodeText = obj.barcodeText.replace(/\s+/g, '');
                    obj.barcodeText = obj.barcodeText.replace(/\s/g, '');
                    obj.barcodeText = obj.barcodeText.substring(6);
                    self.getScannedPartsCounts(obj.barcodeText, barcodeIndex);
                    obj.isBlurEventCall = true;
                    // console.log(JSON.stringify(self.barcodeArr));
                    self.barcodeArr.push(Vue.util.extend({}, self.barcodeObject));
                    setTimeout(function() {
                        self.$refs.barcodeTextRef[0].focus();
                    }, 200);
                } else {
                    self.qrcodeCount = self.barcodeArr.length - 1;
                    self.barcodeEventCallback(self.qrcodeCount);
                }
            },
            returnOnListing(){
                if(self.isFromPartModule == 'parts') {
                    self.$router.push({name:'ListInventory'});
                } else {
                    if (self.partId.value != undefined) {
                        self.$router.push({name:'CustomerOrderHistory'});
                    } else {
                        self.$router.push({name:'CustomerDashboard'});
                    }
                }
            },
            removeErrorMessageOnInput : function () {
                /* Remove error on input */
                $("#partId").keyup(function () {
                    self.partError = "";
                });
            },
            getAllInventoryParts: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                HTTP.get('/get-inventorypartsdetail', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.partArr = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getScannedPartsCounts: function(partNo, scannedIndex) {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        part_no: partNo,
                        is_web: true,
                    }
                };
                HTTP.get('/inventory/check-part-by-id', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.barcodeArr[scannedIndex].maxQty = response.data.content[0].inventory_qty;
                            if(response.data.content && response.data.content.length > 0) {
                                if(response.data.content && response.data.content.length > 1) {
                                    self.barcodeArr[scannedIndex].barcodeText = response.data.content[0].strip_part_no;
                                    self.barcodeArr[scannedIndex].isColorChnage = true;
                                    for(var index = 1; index < response.data.content.length; index++) {
                                        var object = response.data.content[index];

                                        self.barcodeArr.push(Vue.util.extend({}, self.barcodeObject));
                                        self.barcodeArr[scannedIndex + index].barcodeText = object.strip_part_no;
                                        self.barcodeArr[scannedIndex + index].maxQty = object.inventory_qty;
                                        self.barcodeArr[scannedIndex + index].isBlurEventCall = true;
                                        self.barcodeArr[scannedIndex + index].isColorChnage = true;
                                    }
                                }
                            }
                        }
                        if (response.status == '201') {
                            // self.barcodeArr[scannedIndex].isBlurEventCall = false;
                            self.barcodeArr[scannedIndex].isDisabledQty = true;
                            self.barcodeArr[scannedIndex].note = 'Part not found!';
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            getPartsCounts: function(partNo) {
                self.isCorePartAvailable = false;
                self.corePartPrice = '';
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        part_no: partNo,
                        is_web: true,
                    }
                };
                HTTP.get('/inventory/check-part-by-id', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.maxQty = response.data.content[0].inventory_qty;
                            self.scannedPartId = response.data.content[0].part_id;
                            self.auditCount = response.data.auditCount;
                            if(response.data.content[0].is_core_part_available == 'yes') {
                                self.isCorePartAvailable = true;
                                self.corePartPrice = response.data.content[0].core_part_unit_price;
                            }
                        }
                        if (response.status == '201') {
                            self.isPartEnter = false;
                            self.partId = '';
                            self.showSAlert(response.data.content, 'info', false);
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            validateForm(){
                var error = false;
                self.partError = '';
                self.qtyError = '';
                self.workOrderError = '';
                self.purchaseWorkOrderError = '';

                if (self.partId == null || !self.partId.value) {
                    self.partError = "The part field is required.";
                    error = true;
                }
                if((self.partId != null || self.partId.value) && self.isPartEnter) {
                    if (self.qty <= 0) {
                        self.qtyError = "Please enter valid Qty";
                        return true;
                    }
                    if (typeof(self.$route.params.qty) != "undefined" && self.$route.params.qty != "" && self.$route.params.qty != 0 && self.editId != 0 && self.$route.params.qty >= self.qty) {
                    } else {
                        if (self.qty <= 0) {
                            self.qtyError = "Please enter valid Qty";
                            error = true;
                        } else if (!self.allnumeric(self.qty)) {
                            self.qtyError = "Only Number Allowed";
                            error = true;
                        } else {
                            if(typeof(self.$route.params.qty) != "undefined" && self.$route.params.qty != "" && self.$route.params.qty != 0) {
                                if ( parseInt(self.qty) > (parseInt(self.maxQty) + parseInt(self.$route.params.qty)) ) {
                                    self.qtyError = "Qty can't be greater than QOH";
                                    error = true;
                                }
                            } else {
                                if ( parseInt(self.qty) > parseInt(self.maxQty) ) {
                                    self.qtyError = "Qty can't be greater than QOH";
                                    error = true;
                                }
                            }
                        }
                    }
                    if (self.workOrder && self.workOrder.length > 15) {
                        self.workOrderError = "Work Order must be less than 15 Characters";
                        error = true;
                    }
                    if(!self.purchaseWorkOrder) {
                        self.purchaseWorkOrderError = "Please Enter PO Number";
                        error = true;
                    }
                    if (self.purchaseWorkOrder && self.purchaseWorkOrder.length > 12) {
                        self.purchaseWorkOrderError = "PO Number must be less than 12 Characters";
                        error = true;
                    }
                }
                return error;
            },
            allnumeric : function (inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },
            closeAuditInventory: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                var fields = {};
                HTTP.post("/close/audit/inventory/customer", fields, config)
                    .then(function (data) {
                        self.buttonNames.saveButton = "Save";
                        self.disableButtons.saveButton = false;
                        if (data.status == 200) {
                            self.getUsageCustomerPart();
                        }
                    })
                    .catch(function (error) {
                        self.error_msg_login = "";
                        self.buttonNames.saveButton = "Save";
                        self.disableButtons.saveButton = false;
                        self.catchHandler(error);
                    })
            },
            storePart: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                };
                var fields = {
                    part_id: self.scannedPartId,
                    qty: self.qty,
                    work_order: self.workOrder,
                    purchase_work_order: self.purchaseWorkOrder,
                    edit_id: self.editId,
                    tz: moment.tz.guess(),
                    part_usage_id: self.selectedPartUsage,
                };
                // console.log(JSON.stringify(fields));return false;
                HTTP.post("/create-part-depletion-history", fields, config)
                    .then(function (data) {
                        self.buttonNames.saveButton = "Save";
                        self.disableButtons.saveButton = false;
                        if (data.status == 200) {
                            self.returnOnListing();
                            self.showSAlert('Part used successfully', 'success', false);
                        }
                    })
                    .catch(function (error) {
                        self.error_msg_login = "";
                        self.buttonNames.saveButton = "Save";
                        self.disableButtons.saveButton = false;
                        self.catchHandler(error);
                    })
            },
            closeModalEvent: function() {
                self.selectedPartUsage = [];
                self.storePart();
            },
            changeDateWisePart: function(selectedDate) {
                self.selectedPartUsage = [];
                if (!self.isSelectAllParts) {
                    for (let key in self.partUsageArr[selectedDate]) {
                        self.selectedPartUsage.push(self.partUsageArr[selectedDate][key]);
                    }
                }
            },
            changePartUsage: function() {
                if (self.selectedPartUsage.length == Object.keys(self.partUsageArr).length) {
                    self.isSelectAllParts = true;
                } else {
                    self.isSelectAllParts = false;
                }
                // console.log(JSON.stringify(self.selectedPartUsage));
            },
            selectAllUsedParts: function () {
                self.selectedPartUsage = [];
                if (!self.isSelectAllParts) {
                    for (let key in self.partUsageArr) {
                        for (let jkey in self.partUsageArr[key]) {
                            self.selectedPartUsage.push(self.partUsageArr[key][jkey]);
                        }
                    }
                }
            },
            submitPartUsageData: function() {
                if(self.selectedPartUsage.length == 0) {
                    self.showSAlert("Please Select at least one checkbox", 'info', false);
                    return false;
                }
                self.storePart();
            },
            getUsageCustomerPart: function() {
                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    },
                    params: {
                        edit_id: self.editId,
                        tz: moment.tz.guess(),
                    },
                };
                HTTP.get('/usage/customer/part/get', config)
                    .then(function (response) {
                        if (response.status == '200') {
                            self.partUsageArr = response.data.content;
                            /* console.log(Object.keys(self.partUsageArr).length);
                            console.log(JSON.stringify(self.partUsageArr));return false; */
                            if(self.partUsageArr && Object.keys(self.partUsageArr).length > 0) {
                                self.$refs['my-modal'].show();
                            } else {
                                self.storePart();
                            }
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err);
                    })
            },
            checkInventoryPart() {
                var error = self.validateForm();
                if(!error) {
                    self.buttonNames.saveButton = "Saving ...";
                    self.disableButtons.saveButton = true;
                    // if(self.auditCount == 1) {
                    if(self.isFromPartModule == 'dashboard' && self.isAuditedPart == 1) {
                        self.$swal({
                            title: "Audit Acknowledgement",
                            input: 'checkbox',
                            inputValue: 0,
                            inputPlaceholder: "I acknowledge that the Audit is complete",
                            type: "info",
                            showConfirmButton: true,
                            showCloseButton: true,
                            showCancelButton: true,
                            confirmButtonText: "Yes",
                            cancelButtonText: "No",
                            showLoaderOnConfirm: true,
                            inputValidator: (result) => {
                                return !result && 'Please acknowledge that the Audit is complete'
                            }
                        })
                        .then(result => {
                            if (result.value) {
                                self.closeAuditInventory();
                            } else {
                                self.buttonNames.saveButton = "Save";
                                self.disableButtons.saveButton = false;
                            }
                        });
                    } else {
                        self.getUsageCustomerPart();
                    }
                }
            },
            checkForm: function () {
                var checked = true;
                if(!self.barcodeArr[0].isBlurEventCall) {
                    setTimeout(function() {
                        self.$refs.barcodeTextRef[0].focus();
                    }, 200);
                    if (checked) {
                        checked = false;
                    }
                    self.showSAlert("Please scan at least one part", 'info', false);
                    return checked;
                }
                self.barcodeArr.forEach(function (object, index) {
                    object.qtyError = "";
                    object.unitNumberError = "";
                    if(object.barcodeText && object.note == '') {
                        if (object.unitNumber && object.unitNumber.length > 15) {
                            object.unitNumberError = "Work Order must be less than 15 Characters";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (object.qty <= 0) {
                            object.qtyError = "Please enter valid Qty";
                            if (checked) {
                                checked = false;
                            }
                        } else if(object.qty && !self.allnumeric(object.qty)) {
                            object.qtyError = "Only Number Allowed";
                            if (checked) {
                                checked = false;
                            }
                        } else if( parseInt(object.qty) > parseInt(object.maxQty) ) {
                            object.qtyError = "Qty can't be greater than QOH";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                });
                return checked;
            },
            addUpdatePart: function() {
                setTimeout(() => {
                    if (self.checkForm()) {
                        console.log(JSON.stringify(self.barcodeArr));
                        var config = {
                            headers: {
                                Authorization: "Bearer " + localStorage.getItem("api_token")
                            },
                        };
                        var fields = {
                            scanned_part: self.barcodeArr
                        };
                        HTTP.post("/partdepletionhistory/add", fields, config)
                            .then(function (data) {
                                self.buttonNames.saveButton = "Save";
                                self.disableButtons.saveButton = false;
                                if (data.status == 200) {
                                    self.returnOnListing();
                                    self.showSAlert('Part used successfully', 'success', false);
                                }
                            })
                            .catch(function (error) {
                                self.error_msg_login = "";
                                self.buttonNames.saveButton = "Save";
                                self.disableButtons.saveButton = false;
                                self.catchHandler(error);
                            })
                    }
                }, 200);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Customer/CustomerUseParts.vue